import { faTrash } from '@fortawesome/free-solid-svg-icons'
import type { FC } from 'react'

import IconButton from '@/components/IconButton'

interface Props {
  onRemove: () => void
}

const RemoveButton: FC<Props> = ({ onRemove }) => (
  <IconButton iconSize="lg" tooltipMessage="Remove" icon={faTrash} onClick={onRemove} />
)

export default RemoveButton
